import langEN from './en';
import langDE from './de';
import langFR from './fr';
import langBR from './br';
import langCZ from './cz';

export default {
  en: langEN,
  de: langDE,
  fr: langFR,
  br: langBR,
  cz: langCZ,
};
